import moment from 'moment';
import history from '../App/History';
import { mutateLogoutAPI } from '../Services/login.api';

interface ISetToken {
  token: string;
  tokenRefresh: string;
}

const initialState: any = {
  token: '',
  tokenRefresh: '',
  lastActionTimeStamp: moment().format('YYYY-MM-DD HH:mm:ss'),
  auth: {
    user: {
      name: '',
    },
  },
};

const authSlice = (set: any, get: any) => ({
  ...initialState,
  setConfiguration: (configuration: any) => {
    set(() => ({
      configuration,
    }));
  },
  setToken: ({ token, tokenRefresh }: ISetToken) =>
    set(() => {
      if (token && tokenRefresh) {
        const momentNow = moment().format('YYYY-MM-DD HH:mm:ss');
        const lastActionTimeStamp = momentNow;
        const jwtDecode = require('jwt-decode');
        const decodedAuth = jwtDecode(token);

        return {
          token,
          tokenRefresh,
          auth: decodedAuth,
          lastActionTimeStamp,
        };
      } else {
        return initialState;
      }
    }),
  logOut: async () => {
    const urlCallback = get().configuration?.callbackUrl;
    const tokenRefresh = get().tokenRefresh;

    try {
      if (tokenRefresh) {
        await mutateLogoutAPI(tokenRefresh);
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }

    set(() => initialState);

    if (urlCallback) {
      window.location.replace(urlCallback);
    } else {
      history.push(`${process.env.REACT_APP_PUBLIC_URL}/login`);
    }
  },
});

export default authSlice;
